module.exports = {"532324101":"龙川镇","532324102":"沙桥镇","532324103":"五街镇","532324104":"红土坡镇","532324105":"马街镇","532324106":"兔街镇","532324201":"雨露白族乡","532324202":"一街乡","532324203":"罗武庄乡","532324204":"五顶山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532324.json
// module id = 2753
// module chunks = 0